import styled from 'styled-components'
import { mainColor } from '../../styles/global';

export const EarlyAccessWrapper = styled.div`
    background: #F4F7FF;
    padding:7% 3%;

   > div{
        background: #FAFAFA;
        box-shadow: 3px 10px 15px rgba(38, 50, 56, 0.05);
        border-radius: 24px;
        display:grid;
        grid-template-columns:1fr 1fr;
        padding:7% 7%;
        width:90%;
        gap:2rem;
        margin:auto;
        @media screen and (max-width: 768px) {
            grid-template-columns:1fr;
            width:100%;

        }
    }
`;

export const FormSection = styled.div`

`;


export const ImageSection = styled.div`
    justify-content:center;
    align-items:center;
    display: flex;
    img{
        height: 50%;
        width:100%;
        justify-content: center;
        align-items:center;
    }
    @media screen and (max-width: 768px) {
        display:none;
    }
`;

export const Form = styled.form`
    >h1{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 800;
        font-size: 48px;
        line-height: 80px;
        color: ${mainColor};
        @media screen and (max-width: 768px) {
            font-family: 'Avenir';
            font-style: normal;
            font-weight: 750;
            font-size: 25px;
            line-height: 30px;
        }
    }
    p{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 25px;
        margin-bottom:20px;
        letter-spacing: 0.01em;
        color: #8D8D8D;
        @media screen and (max-width: 768px) {
            font-size: 14px;
            line-height: 30px;
            letter-spacing: 0.01em;
            color: #8D8D8D;
        }
    }
    >div{
        display:flex;
        flex-direction: column;
        color: ${mainColor};
        width:100%;
        padding:0.5rem 0;
        &:hover{
            transition: all ease-in-out .3s;
            transform: translateX(3px);
            cursor: pointer;
            opacity: 0.7;
        }
        label{
            font-family: 'Avenir';
            font-style: normal;
            font-weight: 500;
            font-size: 21px;
            line-height: 33px;
            margin-top:10px;
            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }
        input{
            padding:1.3rem 1rem;
            border: 1.2px solid #828282;
            border-radius: 7px;
            background:transparent;
            width:100%;
            ::placeholder{
                font-family: 'Avenir';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 22px;
                letter-spacing: 0.01em;
                color: #8D8D8D;
            }
        }
        .textarea{
            height:fit-content;
            padding:1.3rem 1rem;
            border: 1.2px solid #828282;
            border-radius: 7px;
            background:transparent;
            width:100%;
        }
        button{
            padding:20px 30px;
            width: 100%;
            color:#fff;
            background: ${mainColor};
            border-radius: 9px;
            font-size:14px;
            &:hover{
                transition: all ease-in-out .3s;
                transform: translateX(3px);
                cursor: pointer;
                opacity: 0.7;
            }
        }
    }

`;